import { Component, OnInit, OnDestroy } from '@angular/core';
import { APIService } from '../common/api.component';
import { Utils } from '../common/utils.component';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { SharedService } from '../common/shared.service';
import { Constants } from '../common/constants';
import { MatDialog } from '@angular/material/dialog';
import { ShareLink } from '../models/sharelink';
import { SortByPipe } from '../pipes/sort-by.pipe';
import { ShareUtils } from '../common/shareutils';
import { takeUntil } from "rxjs/operators";
import { APIData } from '../common/APIData';

export enum SelectionType {
  All,
  Sites,
  Folders,
  Files
}
@Component({
  selector: 'app-favourite',
  templateUrl: './favourite.component.html',
})
export class FavouriteComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  private onDestroy$: Subject<void> = new Subject<void>();
  isShare: boolean;

  constructor(
    private apiService: APIService,
    private utils: Utils,
    private route: Router,
    private sharedService: SharedService,
    private dialog: MatDialog,
    private sortbyPipe: SortByPipe,
    private shareUtils: ShareUtils
  ) {
    this.subscription = sharedService.activeSort$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        activeSort => {
          this.activeSort = activeSort;
          this.setSortOptions()
        });

    this.subscription = sharedService.isShare$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        isShare => {
          this.isShare = isShare;
          if (!this.isShare) {
            this.sharebutton.isDisabled = true
          }
        });

    this.subscription = sharedService.searchedText$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        searchText => {
          this.clearErrorMsg()
          this.searchText = searchText;
        });

    this.subscription = sharedService.activeFilter$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        filter => {
          if (filter == "All")
            this.selectionType = SelectionType.All;
          else if (filter == "Sites")
            this.selectionType = SelectionType.Sites;
          else if (filter == "Folders")
            this.selectionType = SelectionType.Folders;
          else if (filter == "Files")
            this.selectionType = SelectionType.Files;

          this.dataSelection(this.selectionType);
        });

    this.searchText = '';
    this.clickedRow = function (item) {
      this.clearErrorMsg()
      this.highlightRow = item;
      this.sharebutton.isDisabled = false;
    }
  }

  loading: boolean = true;
  favourites: FavouriteItem[];
  clickedRow: any;
  highlightRow: FavouriteItem;
  searchText;
 // sharetitle: string;
  //isDisabled: boolean = true;
  share = new ShareLink();
  activeSort: string;
  selectionType: SelectionType = SelectionType.All;


  offset: number = 0;
  limit: number = 100;

  isSiteCall: boolean = true;
  isFolderCall: boolean = true;
  isFileCall: boolean = true;
  siteCount: number = 0;
  folderCount: number = 0;
  fileCount: number = 0;
  isButtonVisible: boolean = false;
  contenttype: string;
  isFilterRunning: boolean;
  isActiveTab: boolean;
  loadingMessage: string;

  noFavourites = Constants.NO_FAVOURITES
  noFavouritesSites = Constants.NO_FAVOURITES_SITES
  noFavouritesFiles = Constants.NO_FAVOURITES_FILES
  noFavouritesFolders = Constants.NO_FAVOURITES_FOLDERS
  errorMsg = { str: "" }
  sharebutton={isDisabled:true,sharetitle:"",sharetitledefault:""}
 // sharetitledefault = Constants.SHARE_LINK

  ngOnInit() {
    this.apiService.ValidateMsTeamContextAndFatchTeamsId(this.sharedService);
    this.apiService.setTheme();
    this.sharedService.setLoading(this.loading);
    this.sharedService.setInsideFolderfiles(false);
    this.sharedService.setSeachText("")
    this.isFilterRunning = true;
    this.isActiveTab = true;
    this.sharedService.setFilter("All");
    this.isFilterRunning = false;
    if (localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'true' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'undefined' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) == null) {
      this.sharebutton.sharetitle = Constants.NEXT;
      this.sharebutton.sharetitledefault = Constants.NEXT;
    }
    else {
      this.sharebutton.sharetitle = Constants.SHARE_LINK;
      this.sharebutton.sharetitledefault = Constants.SHARE_LINK;
    }
    this.favourites = undefined
    this.contenttype = "Site"
    this.activeSort = this.sharedService.currentactiveSort$.getValue();
    if (this.activeSort === undefined)
      this.activeSort = "nameaz"
    this.getFavourites(this.contenttype)
  }

  ngAfterViewChecked() {
    if (!this.loading) {
      this.utils.setContentHeight(this.isButtonVisible, true, false, false, false);
    }
  }

  getFavourites(contenttypes) {
    this.clearErrorMsg()
    if (contenttypes == null) {
      if (this.isSiteCall && this.selectionType === SelectionType.Sites || this.selectionType === SelectionType.All)
        this.contenttype = 'Site';
      else if (this.isFolderCall && this.selectionType == SelectionType.Folders)
        this.contenttype = 'folder';
      else if (this.isFileCall && this.selectionType === SelectionType.Files)
        this.contenttype = 'files';
    }
    this.apiService.getFavourites(this.contenttype, this.offset, this.limit)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (favlist) =>{
        var favoritedata = favlist['favoritecontent'];

        if (this.contenttype === 'Site') {
          favoritedata = favoritedata.map(favorite => ({
            ...favorite,
            title: `${favorite['contenttitle']}`,
            newtype: 'site'
          }));
          this.siteCount += favoritedata.length;
          if (favoritedata.length < this.limit) {
            this.setApiCallBasedOnType(false, this.selectionType != SelectionType.Sites, this.selectionType != SelectionType.Sites);
            this.offset = 0;
          } else { this.offset += this.limit; }
        }
        else if (this.contenttype === 'folder') {
          favoritedata = favoritedata.map(favorite => ({
            ...favorite,
            title: `${favorite['contenttitle']}`,
            newtype: 'folder'
          }));
          this.folderCount += favoritedata.length;
          if (favoritedata.length < this.limit) {
            this.setApiCallBasedOnType(false, false, this.selectionType != SelectionType.Folders);
            this.offset = 0;
          } else { this.offset += this.limit; }
        }
        else {
          favoritedata = favoritedata.map(favorite => ({
            ...favorite,
            title: `${favorite['contenttitle']}.${favorite['extension']}`,
            newtype: 'file'
          }));

          this.fileCount += favoritedata.length;
          if (favoritedata.length < this.limit) {
            this.setApiCallBasedOnType(false, false, false);
            this.offset = 0;
          } else { this.offset += this.limit; }
        }
        for (let item of favoritedata) {
          if (this.contenttype === 'Site') {
            item.createdby = {
              firstname: '',
              lastname: '',
            }
          }
        }
        if (this.favourites) {

          for (let item of favoritedata) {
            this.favourites.push(item);
          }
        }
        else {
          this.favourites = favoritedata;
        }

        this.favourites = this.favourites.filter(data => data.extension != "placeholder")

        if (favoritedata.length < this.limit) {
          if (this.contenttype === 'Site' && this.selectionType != SelectionType.Sites) {
            this.contenttype = 'folder'
            this.loadMore(this.contenttype, false);
          } else if (this.contenttype === 'folder' && this.selectionType != SelectionType.Folders) {
            this.contenttype = 'files'
            this.loadMore(this.contenttype, false);
          } else {
            this.setSortOptions();
            this.loading = false;
            this.sharedService.setLoading(this.loading);
            this.isButtonVisible = false;
          }
        } else {
          this.setSortOptions();
          this.loading = false;
          this.sharedService.setLoading(this.loading);
          this.isButtonVisible = true;
          this.loadingMessage = Constants.LOAD_MORE_RESULTS
        }
      }, 
      error: (err) => {
        this.loading = false
        this.sharedService.setLoading(this.loading);
        /* this.utils.openErrorDialog({ errorData: err }, this.dialog, item => {
        }) */
        this.errorMsg.str = err.errorMsg

      }
      });
  }

  public loadMore(contenttype, fromHtml) {
    this.clearErrorMsg()
    if ((!this.isSiteCall && !this.isFolderCall && !this.isFileCall) || (fromHtml && this.loadingMessage == 'Loading...'))
      return;
    this.loadingMessage = Constants.LOADING
    this.getFavourites(contenttype);
  }

  public dataSelection(type: SelectionType) {
    this.clearErrorMsg()
    if (!this.isFilterRunning && this.isActiveTab) {
      this.selectionType = type;
      this.resetParameters();
      this.loadingMessage = Constants.LOADING
      this.loading = true;
      this.sharedService.setLoading(this.loading);
      this.getFavourites(null);
    }
  }

  public setApiCallBasedOnType(siteCall: boolean, folderCall: boolean, fileCall: boolean) {
    this.isSiteCall = (siteCall && this.selectionType != SelectionType.Files && this.selectionType != SelectionType.Folders);
    this.isFolderCall = (folderCall && this.selectionType != SelectionType.Files && this.selectionType != SelectionType.Sites);
    this.isFileCall = (fileCall && this.selectionType != SelectionType.Folders && this.selectionType != SelectionType.Sites);
  }

  public resetParameters() {
    this.offset = 0;
    this.siteCount = 0;
    this.folderCount = 0;
    this.fileCount = 0;
    this.favourites = undefined;
    this.setApiCallBasedOnType((this.selectionType != SelectionType.Folders && this.selectionType != SelectionType.Files), this.selectionType == SelectionType.Folders, this.selectionType == SelectionType.Files);
  }

  getParentIdfromlink(link) {
    var splitted = link.split("parentFolderID=");
    var splitted1 = splitted[1].split("&");
    return splitted1[0];
  }

  getSiteIdfromlink(link) {
    var splitted = link.split("siteID=");
    var splitted1 = splitted[1].split("&");
    return splitted1[0];
  }

  public getFileIcon(type: string) {
    return this.utils.getFileIcon(type);
  }

  groupData() {
    const grouped = this.utils.groupBy(this.favourites, folder => folder.contenttype);
    this.favourites = grouped.get("Site");
    var isDone = false;

    if (this.favourites != undefined && this.favourites) {
      if (grouped.get("Folder")) {
        for (let item of grouped.get("Folder"))
          this.favourites.push(item)
      }
      if (grouped.get("Document")) {
        for (let item of grouped.get("Document"))
          this.favourites.push(item)
      }
      isDone = true;
    } else if (grouped.get("Folder") != undefined) {
      this.favourites = grouped.get("Folder");
      if (this.selectionType == SelectionType.Folders)
        isDone = true;
    }

    if (!isDone && this.favourites != undefined && this.favourites) {

      if (grouped.get("Document")) {
        for (let item of grouped.get("Document"))
          this.favourites.push(item)
      }
      else if (grouped.get("Document") != undefined) {
        this.favourites = grouped.get("Document");
      }
    } else if (!isDone && grouped.get("Document") != undefined) {
      this.favourites = grouped.get("Document");
    }
  }

  openFolder(item, contenttype: string, contentId: number, contentTitle: string, httplink: string) {
    this.clearErrorMsg()
    if (contenttype === 'Folder') {
      var folderobj = {
        name: item.contenttitle,
        type: item.extension,
        id: item.contentid,
        location: item.location,
        size: item.contentsize,
        modifieddate: item.contentupdateddate,
        foldertype: item.foldertype
      }
      this.route.navigate(['/folder', contentId, 'Favourites', contentTitle], { state: { siteId: this.getSiteIdfromlink(httplink), parentfolderType: item.foldertype, parentfolder: folderobj } });

    } else if (contenttype === 'Site') {
      this.getFolderInfo(this.getParentIdfromlink(httplink), contentTitle, contentId, item.contentupdateddate)
    }
    else {
      this.clickedRow(item)
    }
  }

  public getFolderInfo(parentFolderId, contentTitle, contentId, lastmodified) {
    this.loading = true
    this.sharedService.setLoading(this.loading);
    this.apiService.getFolderInfo(parentFolderId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        this.loading = false
        this.sharedService.setLoading(this.loading);
        this.route.navigate([`/folder`, parentFolderId, 'Favourites', contentTitle], { state: { siteId: contentId, siteName: contentTitle, siteLastModified: lastmodified } });
      }, err => {
        if (err.refCode >= 432 && err.refCode <= 434) {
          this.apiService.getSite(contentId).subscribe(data => {
            this.loading = false
            this.sharedService.setLoading(this.loading);
            err.sites = this.utils.getSiteTemp(data, contentId)
            err.apiData = this.gatherAPIData(parentFolderId, contentTitle)
            this.utils.openErrorDialog({ errorData: err }, this.dialog, item => {
              if (item == true) {
                this.route.navigate(['/folder', parentFolderId, 'Favourites', contentTitle], { state: { siteId: contentId, siteName: contentTitle, siteLastModified: lastmodified } });
              } else if (item != false) {
                this.errorMsg.str = item
              }
            })
          }, errdata => {
            this.loading = false
            this.sharedService.setLoading(this.loading);
            /* this.utils.openErrorDialog({ errorData: errdata }, this.dialog, item => {
              // Error callback can be put here
            }) */
            this.errorMsg.str = errdata.errorMsg
          })
        } else {
          this.loading = false
          this.sharedService.setLoading(this.loading);
          /* this.utils.openErrorDialog({ errorData: err }, this.dialog, item => {
            // Error callback can be put here
          }) */
          this.errorMsg.str = err.errorMsg
        }

      });
  }
  gatherAPIData(parentFolderId, contentTitle): any {
    var apiData = new APIData()
    apiData.apiToCall = Constants.WS_FAVOURITE
    apiData.parentFolderId = parentFolderId
    var arr = []
    arr.push(contentTitle)
    apiData.additionalData = arr
    return apiData
  }

  shareItem() {
    this.clearErrorMsg()
    var file = this.highlightRow
    if (file.contenttype == 'Folder' && file.foldertype && file.foldertype == 'SMART') {
      this.errorMsg.str = Constants.SMART_FOLDER_SHARE_LINK;
      return;
    }

    var types;
    var filefoldername;
    if (file.contenttype == 'Folder' || file.contenttype == 'Site') {
      filefoldername = file.contenttitle
      types = 'folder';
    }
    else {
      filefoldername = file.contenttitle + "." + file.extension;
      types = 'file';
    }
    var contentId;
    if (file.contenttype == 'Site') {
      contentId = this.getParentIdfromlink(file.httplink)
    } else {
      contentId = file.contentid;
    }
    var fileFolderobj = {
      filefoldername: filefoldername,
      types: types,
      fileType: file.extension,
      contentId: contentId,
      locations: file.contenttype == 'Site' ? file.contenttitle : file.location,
      fileSize: file.contentsize,
      lastmodified: file.contentupdateddate,
      foldertype: file.foldertype
    }
    if (localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'true' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'undefined' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) == null) {
      this.utils.openDialog(this.apiService, this.dialog, fileFolderobj, this.shareUtils, this.share, false, this.sharedService, this.errorMsg,this.sharebutton);
    } else {
      this.sharebutton.sharetitle = Constants.GENERATING_LINK
      this.sharebutton.isDisabled=true;
      if (localStorage.getItem(Constants.LINKEXPIRES_STORAGE) != null) {
        this.shareUtils.generateSharelink(fileFolderobj, this.share, this.apiService, null, this.utils, this.dialog, this.shareUtils, this.sharedService, this.errorMsg,this.sharebutton)
      } else {
        this.utils.getSettings(this.apiService, this.dialog, false, fileFolderobj, this.shareUtils, this.share, false, this.sharedService, this.errorMsg,this.sharebutton)
      }
    }
  }

  public ngOnDestroy(): void {
    // prevent memory leak when component destroyed
    this.isActiveTab = false;
    this.subscription.remove(this.subscription);
    this.subscription.unsubscribe();
    this.onDestroy$.next();
  }

  setSortOptions() {
    this.clearErrorMsg()
    if (this.activeSort == 'nameaz' || this.activeSort == 'nameza')
      this.favourites = this.sortbyPipe.transform(this.favourites, true, this.activeSort == 'nameaz' ? 'asc' : 'desc', 'contenttitle');
    else if (this.activeSort == 'dateoldnew' || this.activeSort == 'datenewold') {
      this.favourites = this.sortByDate()
      if (this.activeSort == 'datenewold') {
        this.favourites = this.reverseList()
      }
    } else if (this.activeSort == 'sizesl') {
      this.favourites = this.sortbySizeSL();
    } else if (this.activeSort == 'sizels') {
      this.favourites = this.sortbySizeLS();
    }
    this.groupData();
  }

  sortByDate() {
    return this.favourites.sort((a: any, b: any) =>
      new Date(a.contentupdateddate).getTime() - new Date(b.contentupdateddate).getTime()
    );
  }
  reverseList() {
    return this.favourites.reverse();
  }

  sortbySizeSL() {
    return this.favourites.sort((a: any, b: any) =>
      a.contentsize - b.contentsize
    );
  }

  sortbySizeLS() {
    return this.favourites.sort((a: any, b: any) =>
      b.contentsize - a.contentsize
    );
  }

  closeDialog() {
    this.shareUtils.closeMainDialog(this.apiService);
  }

  getText(title, extension, isextension) {
    if (extension && isextension)
      return this.utils.getHtmlEncodeString(title) + "." + extension;
    else if (extension)
      return "by " + title + " " + extension;
    else
      return this.utils.getHtmlEncodeString(title);
  }

  clearErrorMsg() {
    this.errorMsg.str = ""
  }
}



export interface FavouriteItem {
  contentid: number;
  contenttitle: string;
  contenttype: string;
  contentsize: number;
  extension: string;
  sitename: string;
  foldertype: string;
  contentupdateddate: string;
  location: string;
  httplink: string;
  createdby: CreatedBy;
  modifiedby: CreatedBy;

}
export interface CreatedBy {
  userid: number;
  firstname: string;
  lastname: string;
}
